import { HeadModule } from "./HeadModule";
var Head = function Head2(param) {
  var { children } = param;
  return children;
};
Object.assign(Head, HeadModule);
export {
  Head
};
//# sourceMappingURL=Head.js.map
